import {ReactElement} from 'react';
import useUserContext from 'shared/contexts/UserContext/useUserContext';
import doctorIsAdmin from 'shared/utils/doctorIsAdmin';
import isDoctor from 'shared/utils/isDoctor';
import HeaderView from './HeaderView';

type Props = {
  onClickHamburger: () => void;
};

function Header({onClickHamburger}: Props): ReactElement {
  const {user} = useUserContext();

  return (
    <HeaderView
      onClickHamburger={onClickHamburger}
      user={user}
      isDoctor={isDoctor(user)}
      doctorIsAdmin={isDoctor(user) && doctorIsAdmin(user)}
    />
  );
}
export default Header;
